import { render, staticRenderFns } from "./change-account-modal.component.vue?vue&type=template&id=35af9206&scoped=true"
import script from "./change-account-modal.component.vue?vue&type=script&lang=js"
export * from "./change-account-modal.component.vue?vue&type=script&lang=js"
import style0 from "./change-account-modal.component.vue?vue&type=style&index=0&id=35af9206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35af9206",
  null
  
)

export default component.exports